export default __webpack_public_path__ + "static/media/ic_united_nations.d91aaad3.svg";